<template>
  <div class="TablePage">
    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!---->
      </div>
    </div>
    <div class="tables-top-bar tables-top-bar" ref="optionsTopBar" >
      <div class="filter__bar">
        <div class="filter"><h3>Tables</h3></div>
        <div class="filter">
          <span class="pad-rg-5">{{$t('dashboard.selectLocation')}}</span>
          <select class="form-control inline-auto white " v-model="selectedLocaion">
            <option value="0" selected :label="$t('general.all')">{{$t('general.all')}}</option>
            <template v-for="loc in locations">
              <option
                :label="loc.name"
                :value="loc.true_id"
                :key="loc.true_id"
                > {{loc.name}}
              </option>
            </template>
          </select>
        </div>
        <div class="filter">
          <span class="pad-rg-5">{{$t('dashboard.selectZone')}}</span>
          <select class="form-control inline-auto white " v-model="selectedZone">
            <option value="0" selected :label="$t('general.all')">{{$t('general.all')}}</option>
            <template v-for="loc in zones">
              <option
                :label="loc.name"
                :value="loc.id"
                :key="loc.id"
                > {{loc.name}}
              </option>
            </template>
          </select>
        </div>
        <div class="filter">
          <h3><a class="btn btn-info btn-icon" @click.prevent="getData()"><i class="ti-reload" style="margin-right: 5px;"></i> Cauta</a></h3>
        </div>
      </div>
      <div class="text-right" style="margin-right: 10px;">
        <div class="zoom" @click="goFullScreen()">
          <svg id="Component_2_1" data-name="Component 2 – 1" xmlns="http://www.w3.org/2000/svg" width="58" height="60" viewBox="0 0 58 60">
            <rect id="Rectangle_6606" data-name="Rectangle 6606" width="58" height="60" rx="10" fill="#f3f3f3"/>
            <g id="Icon_feather-maximize-2" data-name="Icon feather-maximize-2" transform="translate(20 21)">
              <path id="Path_24778" data-name="Path 24778" d="M22.5,4.5h6.141v6.141" transform="translate(-10.218 -4.5)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_24779" data-name="Path 24779" d="M10.641,28.641H4.5V22.5" transform="translate(-4.5 -10.218)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_24780" data-name="Path 24780" d="M28.164,4.5,21,11.664" transform="translate(-9.742 -4.5)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              <path id="Path_24781" data-name="Path 24781" d="M4.5,28.164,11.664,21" transform="translate(-4.5 -9.742)" fill="none" stroke="#8f8f8f" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            </g>
          </svg>
        </div>
        <!-- <a class="btn btn-info btn-icon"  @click.prevent="goToAdd"><i class="ti-plus"></i> Adauga Rezervare</a> -->
        <!-- <p class=""> -->
          <!-- <a class="btn btn-info btn-icon"  @click.prevent="goToAdd" :title="$t('general.add') + ' ' + $t('settingUsers.single')"><i class="ti-plus"></i></a> -->
        <!-- </p> -->
      </div>
    </div>
    <div style="display: flex;">
      <div class="tableWrapper">
        <template v-for="table in tableData">
          <div class="card table_card mar-to-15" @click="openOrdersModal(table.id)">
            <div class="card-content">
              
              <div class="title">
                <span style="display: none;">{{table.id}}</span><br>
                <!-- {{table.zone}} {{table.type}} -->
                <span>{{table.type}} {{table.number}}</span>
                <span class="min_max_pers">min_pers: {{table.min_pers || 0}} - max_pers: {{table.max_pers}}</span>
                <hr style="margin: 0;">
                <span>Comenzi: {{table.nr_orders}}</span><br>
                <span>Rezervari: {{table.nr_reservations}}</span><br>
                <template v-if="table.first_date_reservations">
                  <span >Prima rezervare: </span><br>
                  <span>{{formatDateToShowJustDate(table.first_date_reservations)}}</span>
                  <span>{{formatDateToShowJustTime(table.first_date_reservations)}}</span>
                </template>
              </div>
                
            </div>
          </div>
        </template>
      </div>
    </div>


    <vmodal name="ordersModal"
            class="ordersModal"
            width="90%"
            height="90%"
            :maxWidth="900"
            :minWidth="200"
            :adaptive="true"
      >
      <div :class="(loadingOrders ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <template v-if="tableDataInPopup">
        <div class="ordersModal__header">
          <div class="tableHeader">
            <h4 style="margin:0">{{tableDataInPopup.type}} {{tableDataInPopup.number}}</h4>
            <span><b>Zone:</b> {{tableDataInPopup.zone}}</span><br>
            <span v-if="tableDataInPopup.min_pers && tableDataInPopup.max_pers">Intre {{tableDataInPopup.min_pers}} si {{tableDataInPopup.max_pers}} persoane</span>
          </div>
        </div>
        <div class="ordersModal__wrapper">
          
          <div class="cols">
            <div class="col reservation_col">
              <h4>Reservation</h4>
              <div class="reservations">
                <template v-for="reservation in tableDataInPopup.reservations">
                  <div class="reservation" v-if="reservation">
                    <span class="reservation_id">ID: {{reservation.id}}</span>
                    <div class="reservation_data">
                      <table style="text-align: center; margin: 0;">
                         <tr>
                            <td colspan="2">{{formatDateToShowJustDate(reservation.date_from)}}</td>
                          </tr>
                          <tr>
                            <td>{{formatDateToShowJustTime(reservation.date_from)}}</td>
                            <td>{{formatDateToShowJustTime(reservation.date_to)}}</td>
                          </tr>
                      </table>
                    </div>
                    <div class="reservation_data statuses">
                      <template v-if="reservation.status != 'RESERVED'">
                        <button :class="['statusBtn RESERVED']" @click="changeStatusReservation('RESERVED', reservation)">RESERVED</button>
                        <button :class="['statusBtn CANCELED']" @click="changeStatusReservation('CANCELED', reservation)">CANCELED</button>
                      </template>
                      <template v-else>
                        <template v-for="sts in reservationStatuses">
                          <template v-if="reservation.status == 'RESERVED' && sts != reservation.status">
                            <button :class="['statusBtn', 
                                              sts,
                                              reservation.status == sts ? 'active' : ''
                                            ]" @click="changeStatusReservation(sts, reservation)">{{sts}}</button>
                          </template>
                        </template>
                      </template>
                    </div>
                    <div class="reservation_user">
                      <span>Name: {{reservation.name}}</span>
                      <!-- <span>Email: {{reservation.user.email}}</span> -->
                      <span>Phone: {{reservation.phone}}</span>
                      <span>Total Persoane: {{reservation.total_pers}}</span>
                    </div>
                    <div class="reservation_data">
                      <table class="reservation_prices">
                        <tr>
                          <th>Name</th>
                          <th>Price</th>
                        </tr>
                        <template v-for="resItems in reservation.reservations_items">
                          <tr>
                            <td>{{resItems.name}}</td>
                            <td>{{resItems.price}}</td>
                          </tr>
                        </template>
                        <tr>
                          <th>Total Masa:</th>
                          <th>{{reservation.reservations_table[0].table_total_price}}</th>
                        </tr>
                        <tr>
                          <th>Total Rezervare:</th>
                          <th>{{reservation.reservations_table[0].total_price}}</th>
                        </tr>
                        <tr>
                          <td>Payment Type:</td>
                          <td>{{reservation.payment_type}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <div class="col_bar"></div>
            <div class="col order_col">
              <h4>Orders</h4>
              <div class="tables">
                <template v-for="order in tableDataInPopup.order">
                  <div class="order">
                    <span>ID:{{order.id}}</span>
                    <span>TOKEN:{{order.token}}</span>
                    <div class="order_data statuses">
                      <template v-for="sts in statuses">
                        <button :class="['statusBtn', 
                                          sts,
                                          order.status == sts ? 'active' : ''
                                        ]" @click="changeStatus(sts, order)">{{sts}}</button>
                      </template>
                    </div>
                    <div class="order_data">
                      <table class="order_prices">
                        <tr>
                          <th>Name</th>
                          <th>Qty</th>
                          <th>Price</th>
                        </tr>
                        <template v-for="group in order.parts">
                          <template v-for="prod in group.items">
                            <tr>
                              <td>
                                {{prod.name}}
                                <template v-for="option in prod.options">
                                <span>+ {{option.name}}({{option.price}})</span>
                              </template>
                              </td>
                              <td>{{prod.quantity}}</td>
                              <td>{{prod.price}}</td>
                            </tr>
                          </template>
                        </template>
                        <tr>
                          <th>Subtotal:</th>
                          <th></th>
                          <th>{{order.totals_subtotals}}</th>
                        </tr>
                        <tr>
                          <th>Taxe:</th>
                          <th></th>
                          <th>{{order.totals_shipping + order.totals_extras}}</th>
                        </tr>
                        <tr>
                          <th>Total Discount:</th>
                          <th></th>
                          <th>{{order.totals_discount}}</th>
                        </tr>
                        <tr>
                          <th>Tips:</th>
                          <th></th>
                          <th>{{order.totals_tip}}</th>
                        </tr>
                        <tr>
                          <th>Total:</th>
                          <th></th>
                          <th>{{order.totals_grandtotal}}</th>
                        </tr>
                        <tr>
                          <td>Payment Type:</td>
                          <th></th>
                          <td>{{order.payment_type}}</td>
                        </tr>
                      </table>
                    </div>
                    <br>
                    <button @click="goToOrder(order.id)">View Order</button>
                  </div>
                </template>
              </div>
            </div>
          </div>

        </div>
        <!-- <div class="ordersModal__footer">
           
        </div> -->
      </template>
    </vmodal>


  </div>
</template>
<script>
  import Vue from 'vue'
  import moment from 'moment'
  import {Input, Table, TableColumn, Option, Pagination} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import vmodal from 'vue-js-modal'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(Pagination)
  Vue.use(DataTables)
  Vue.use(vmodal, { componentName: 'vmodal' })
  export default {
    components: {
      PPagination,
      [Input.name]: Input
    },
    props: {

    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()
    },
    data () {
      return {
        statuses: ['NEW', 'PROCESSING', 'DELIVERED', 'CANCELED'],
        reservationStatuses: ['RESERVED', 'COMPLETED', 'CANCELED'],
        locations: [],
        zones: [],
        selectedLocaion: 0,
        selectedZone: 0,
        loading: true,
        loadingOrders: true,
        token: null,
        apiUrl: null,
        locationDataForTableManagement: [],
        tableDataInPopup: [],
        tableData: []
      }
    },
    methods: {
      openOrdersModal (tableId) {
        this.$modal.show('ordersModal')
        this.tableDataInPopup = []
        this.loadingOrders = true
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany'),
          table_id: tableId
        }
        this.apiRequest('/get-table-itmes', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableDataInPopup = response.data.table
          }
          this.$nextTick(() => {
            this.loadingOrders = false
          })
        })
        // this.$modal.hide('ordersModal')
      },
      getData () {
        this.loading = true
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany'),
          location_id: this.selectedLocaion,
          table_zones_id: this.selectedZone
        }
        this.apiRequest('/get-table-orders', 'GET', data, (response) => {
          if (response.status === true) {
            this.tableData = response.data.tables
            this.locations = response.data.locations
            this.zones = response.data.zones

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      changeStatus (sts, order) {
        this.loading = true
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany'),
          status: sts,
          id: order.id
        }
        this.apiRequest('/order/' + order.id, 'PUT', data, (response) => {
          if (response.status === true) {
            this.getData()
          } else {
            this.loading = false
          }
        })
      },
      changeStatusReservation (sts, reservations) {
        this.loading = true
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany'),
          status: sts,
          reservation_id: reservations.id
        }
        this.apiRequest('/edit-reservation', 'GET', data, (response) => {
          if (response.status === true) {
            if (this.tableDataInPopup) {
              this.openOrdersModal(this.tableDataInPopup.id)
            }
            // this.tableData = response.data.tables
            // this.$nextTick(() => {
            //   this.loading = false
            // })
          }
        })
      },
      formatDateToShowJustDate (date) {
        if (date) {
          return moment(date).format('DD-MM')
        }
        return ''
      },
      formatDateToShowJustTime (date) {
        if (date) {
          return moment(date).format('hh:mm A')
        }
        return ''
      },
      goToOrder (orderId) {
        this.$router.push('/orders/view/' + orderId)
      },
      goFullScreen () {
        var element = document.querySelector('.TablePage')
        if (this.isFullScreen) {
          document.exitFullscreen()
          this.isFullScreen = false
        } else {
          this.isFullScreen = true
          this.requestFullScreen(element)
        }
      },
      requestFullScreen (element) {
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
        if (requestMethod) { // Native full screen.
          requestMethod.call(element)
        } else if (window.ActiveXObject && typeof window.ActiveXObject !== 'undefined') { // Older IE.
          var wscript = new ActiveXObject('WScript.Shell')
          if (wscript !== null) {
            wscript.SendKeys('{F11}')
          }
        }
      },
      copyToClipboard (textToCopy) {
        textToCopy = textToCopy.replace(/\s/g, '')
        this.$copyText(textToCopy).then(function (e) {
          // alert('Copied')
          // console.log(e)
        }, function (e) {
          // console.log('Can not copy')
          // console.log(e)
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  .tables-top-bar {
    background: white;
    padding: 22px 15px 10px;
    border-bottom: 1px solid #d7d7d7;
    margin: -15px -15px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .ordersModal {
    .el-collapse-item__content {
      color: #000;
    }
    .ordersModal__header {
      height: 100px;
    }
    .ordersModal__wrapper {
      // height: 100%;
      height: calc(100% - 110px);
      overflow: auto;
      width: 100%;
      padding: 0;
      margin: 0;
    }
    .ordersModal__wrapper::-webkit-scrollbar {
        width: 5px;
    }
    .ordersModal__wrapper::-webkit-scrollbar-thumb {
        border-radius: 100px;
        border: 0px solid transparent;
        background-clip: content-box;
        background-color: #674BD2;
    }
    .ordersModal__wrapper::-webkit-scrollbar-track {
        background-color: #e4e4e4;
        border-radius: 100px;
    }
  }
  .filter__bar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 10px;
    .filter {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 0;
      margin-right: 20px;
      h3 {
        margin: 0;
      }
    }
  }
  .title {
    text-align: center;
  }
  .min_max_pers {
    display: block;
    display: none;
  }
  .tableWrapper {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
  }
  .table_card {
    // width: calc(25% - 20px);
    width: 220px;
    height: 220px;
    margin-left: 10px; 
    margin-right: 10px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    // @media screen and (max-width: 1700px) {
    //   width: calc(33.33% - 20px); 
    // }
    // @media screen and (max-width: 1200px) {
    //   width: calc(50% - 20px); 
    // }
    // @media screen and (max-width: 920px) {
    //   width: calc(100% - 20px); 
    // }
  }
  .tableHeader {
    padding: 10px;
    background: #eee;
    margin: 10px;
    border-radius: 15px;
  }
  .cols {
    display: flex;
    // align-items: flex-start; s
    justify-content: flex-start;
    width: 100%;
    .col {
      display: flex;
      width: calc(50% - 21px);
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;
      margin-left: 10px;
      margin-right: 10px;
    }
    .col_bar {
      height: auto;
      width: 1px;
      background: #eee;
    }
    .reservation_col {

    }
    .order_col {

    }
  }
  .tables,
  .reservations {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .order {
    width: 100%;
    position: relative;
    background: #f2f2f2;
    padding: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 15px;
    margin: 10px;
    .order_data,
    .order_user {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
    }
    .order_prices {
    	width: 100%;
    }
    .statuses {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
    }
    .statusBtn {
      font-weight: bold;
      padding: 5px 10px;
      width: calc(50% - 10px);
      margin-bottom: 10px;
      margin-left: 5px;
      margin-right: 5px;
      transition: 0.5s;
      border-radius: 20px;
      &.NEW {
        color: #68B3C8;
        border: 3px solid #68B3C8;
      }
      &.PROCESSING {
        color: #F3BB45;
        border: 3px solid #F3BB45;
      }
      &.DELIVERED {
        color: #7AC29A;
        border: 3px solid #7AC29A;
      }
      &.CANCELED {
        color: #EB5E28;
        border: 3px solid #EB5E28;
      }
      &:hover,
      &.active {
        color: #fff;
        transition: 0.5s;
        &.NEW {
          background-color: #68B3C8;
        }
        &.PROCESSING {
          background-color: #F3BB45;
        }
        &.DELIVERED {
          background-color: #7AC29A;
        }
        &.CANCELED {
          background-color: #EB5E28;
        }
      }
    }
  }
  .reservation {
    width: 100%;
    position: relative;
    background: #f2f2f2;
    padding: 10px;
    margin-top: 20px;
    margin-bottom: 20px;
    border-radius: 15px;
    margin: 10px;
    .reservation_id {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .reservation_prices {
      td, th {
        border: 1px solid #dddddd;
        text-align: left;
        padding: 8px;
      }
      tr:nth-child(even) {
        background-color: #dddddd;
      }
    }
    .rezItems {
      display: flex;
      flex-direction: column;
    }
    .reservation_data,
    .reservation_user {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
    }
    .statuses {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    .statusBtn {
      font-weight: bold;
      padding: 5px 10px;
      width: calc(50% - 10px);
      margin-bottom: 10px;
      margin-left: 5px;
      margin-right: 5px;
      transition: 0.5s;
      border-radius: 20px;
      &.NEW {
        color: #68B3C8;
        border: 3px solid #68B3C8;
      }
      &.RESERVED {
        color: #F3BB45;
        border: 3px solid #F3BB45;
      }
      &.COMPLETED {
        color: #7AC29A;
        border: 3px solid #7AC29A;
      }
      &.CANCELED {
        color: #EB5E28;
        border: 3px solid #EB5E28;
      }
      &:hover,
      &.active {
        color: #fff;
        transition: 0.5s;
        &.NEW {
          background-color: #68B3C8;
        }
        &.RESERVED {
          background-color: #F3BB45;
        }
        &.COMPLETED {
          background-color: #7AC29A;
        }
        &.CANCELED {
          background-color: #EB5E28;
        }
      }
    }
  }
  .reservations-top-bar {
    // height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h2 {
      margin: 0;
    }
  }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>
<style>
  .vm--modal {
    display: block !important;
    /*display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;*/
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Tables/Tables.vue